import styled, { css } from 'styled-components'
import { ListItem, Paper } from '@material-ui/core'
import { ListItemProps } from '@material-ui/core/ListItem'
import { PaperProps } from '@material-ui/core/Paper'
import { colors } from '../../styles'
import { H3 } from '../StyledText'

export const StyledPaper = styled(Paper)`
  overflow-y: auto;
  max-height: 80vh;
` as React.ComponentType<PaperProps>

export const StyledListCaption = styled(H3)`
  color: ${colors.black};
` as React.ComponentType<ListItemProps>

// @ts-ignore -- fix types
export const StyledListItem = styled(ListItem)`
  ${({ titled }: { titled?: boolean }) =>
    !!titled &&
    css`
      opacity: 1;
    `};
` as React.ComponentType<ListItemProps & { titled?: boolean }>

// TODO: merge with CustomDateListField styled datepicker component into one
export const StyledDatePickerWrapper = styled.div`
  display: flex;
  justify-content: center;

  .react-datepicker {
    border: none;
    background-color: transparent;
    font-family: knowledge2017regular;
    font-size: 16px;

    &__header {
      background: none;
      border: none;
    }
    &__day-names {
      display: flex;
      justify-content: space-around;
    }
    &__day-name {
      margin: 0;
    }
    &__current-month {
      font-size: 16px;
      color: ${colors.accent};
    }
    &__week {
      display: flex;
    }
    &__day {
      border-radius: 20px;
      margin: 0.1rem 0.1rem;
      padding: 0;
      &:hover {
        background-color: ${colors.lightAccent};
        border-radius: 20px;
        cursor: pointer;
      }
      &-name {
        color: ${colors.middleAccent};
      }
      &--selected {
        background-color: ${colors.accent};
        &:hover {
          background-color: ${colors.accent};
          border-radius: 20px;
        }
      }
      &--outside-month {
        color: ${colors.grey30};
      }
    }

    &__month {
      margin-top: 0;
    }

    &__navigation {
      &--previous {
        border-right-color: ${colors.accent};
        &:hover {
          border-right-color: ${colors.middleAccent};
        }
      }
      &--next {
        border-left-color: ${colors.accent};
        &:hover {
          border-left-color: ${colors.middleAccent};
        }
      }
    }
  }
` as React.ComponentType<{ theme: string }>
